<template>
  <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 200] }"
      class="elevation-12"
      dense
  >
    <template v-slot:top>
      <div class="px-4">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.postIndex"
                            :items="postIndexes"
                            :item-value="item => item.postCode"
                            :item-text="item => `${item.postCode} - ${item.name}`"
                            label="Пост индекс"
                            :clearable="true"
                            @change="onFiltersChanged"
                            :disabled="$store.getters.appIsOperatorLogin"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-select v-model="filters.region"
                      :items="$store.getters.appLogin.regions"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      label="Область"
                      :clearable="true"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu
                v-model="filterStartMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Начало даты создания"
                    v-model="filterStartDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="true"
                    @input="onChangeFilterStartDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.start"
                  @change="onFilterStartChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-menu
                v-model="filterEndMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Конец даты создания"
                    v-model="filterEndDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="true"
                    @input="onChangeFilterEndDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.end"
                  @change="onFilterEndChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-btn x-large color="primary" dark @click="onRefreshButtonClicked">Обновить</v-btn>
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-slot:item.uid="scope">
      <router-link :to="{name: 'post-package-group', params: {uid: scope.item.uid}}">{{ scope.item.uid }}</router-link>
    </template>
    <template v-slot:item.region="scope">
      {{ scope.item.region.name }}
    </template>
    <template v-slot:item.createdOn="scope">
      {{ scope.item.createdOn.format('DD.MM.YYYY') }}
      <br>
      {{ scope.item.createdOn.format('HH:mm:ss') }}
    </template>
    <template v-slot:item.account="scope">
      {{ scope.item.account.name }}
    </template>
    <template v-slot:item.postIndex="scope">
      {{ scope.item.postIndex ? `${scope.item.postIndex.postCode} - ${scope.item.postIndex.name}` : null }}
    </template>
  </v-data-table>
</template>

<script>
import _ from "underscore";
import Moment from "moment";
import $store from "@/store"


export default {
  name: "PostPackageGroupsDatatable",
  props: {
    postPackageGroups: {
      type: Array,
      default: () => {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      options: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 10,
      },
      filters: {
        region: null,
        start: null,
        end: null,
        postIndex: null
      },
      filterStartMenu: false,
      filterEndMenu: false,
      filterStartDisplayValue: '',
      filterEndDisplayValue: ''
    };
  },
  computed: {
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.postPackageGroups, ppg => {
        ppg.displayNumber = skip + (number++)
        return ppg
      })
    },
    postIndexes(){
      var selectedRegionId = this.filters.region?.id
      var selectedAreaId = this.filters.area?.id

      if(selectedRegionId > 0){
        if(selectedAreaId > 0){
          return $store.getters.appPostIndexes.filter(
              item => item.postRegionCode === selectedRegionId &&
                  item.postDistrictCode === selectedAreaId);
        }
        return $store.getters.appPostIndexes.filter(item => item.postRegionCode === selectedRegionId)
      }
      else{
        return $store.getters.appPostIndexes;
      }
    },
    headers() {
      const headers = []

      headers.push({
        text: '№',
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: 'Идентификатор',
        align: 'left',
        sortable: false,
        value: 'uid'
      })

      headers.push({
        text: 'Дата создания',
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })

      headers.push({
        text: 'Кем создано',
        align: 'left',
        sortable: true,
        value: 'account'
      })

      headers.push({
        text: 'Область',
        align: 'left',
        sortable: true,
        value: 'region'
      })

      headers.push({
        text: 'Отделение',
        align: 'left',
        sortable: true,
        value: 'postIndex'
      })

      return headers
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
  },
  methods: {
    updateItems() {
      this.$emit("update", this.options, this.filters)
    },
    onFiltersChanged() {
      if (this.options.page !== 1)
        this.options.page = 1;
      else
        this.updateItems();
    },
    onRefreshButtonClicked() {
      this.updateItems();
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.filterStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterStartDisplayValue = ''
      }

      this.filterStartMenu = false
      this.updateItems()
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.filterEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterEndDisplayValue = ''
      }

      this.filterEndMenu = false
      this.updateItems()
    },
    onChangeFilterStartDisplayValue() {
      this.filters.start = null;
      this.updateItems()
    },
    onChangeFilterEndDisplayValue() {
      this.filters.end = null;
      this.updateItems()
    }
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  },
  created() {
    if (this.$store.getters.appIsOperatorLogin) {
      this.filters.postIndex = this.$store.getters.appLogin.postIndex
    }
  }
}
</script>

<style scoped>

</style>
